var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9715_150830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6291 0.5L8.76367 5.58L10.0404 2.58619L15.6291 0.5Z",
    fill: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.386844 0.506104L5.96072 2.58667L7.17297 5.61967L0.386844 0.506104ZM12.8662 11.3037L15.9006 11.3615L14.8402 14.9641L11.1375 13.9447L12.8662 11.3037ZM3.13372 11.3037L4.85597 13.9447L1.15953 14.9642L0.105469 11.3615L3.13372 11.3037Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00807 4.84693L7.13213 8.85212L3.42151 8.68331L4.47695 7.09093L4.49032 7.07562L7.00807 4.84693ZM8.95332 4.80225L11.5096 7.07575L11.5228 7.091L12.5783 8.68337L8.86845 8.85212L8.95332 4.80225ZM4.96463 11.3152L6.99076 12.8939L4.63713 14.0302L4.96463 11.3152ZM11.0356 11.3149L11.3563 14.0302L9.00926 12.8937L11.0356 11.3149Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0611 12.7451L11.4428 13.8984L9.22735 14.9512L9.25035 14.2554L9.0611 12.7451ZM6.93816 12.7456L6.75635 14.244L6.77128 14.9504L4.55066 13.8984L6.93816 12.7456Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25047 9.375L6.87284 10.683L4.75391 10.0623L6.25047 9.375ZM9.74953 9.37506L11.2532 10.0623L9.12728 10.6828L9.74953 9.37506Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12668 11.3019L4.78418 14.1169L2.94836 11.3634L5.12668 11.3019ZM10.8736 11.3019L13.0519 11.3634L11.2092 14.117L10.8736 11.3019ZM12.6321 8.52417L11.0467 10.1399L9.82443 9.5813L9.23924 10.8115L8.85561 8.69598L12.6321 8.52417ZM3.36724 8.52417L7.14443 8.69604L6.76074 10.8115L6.17543 9.58148L4.95961 10.1399L3.36724 8.52417Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26038 8.1927L5.054 10.0128L5.11613 11.8096L3.26038 8.1927ZM12.7414 8.18945L10.8823 11.8128L10.9523 10.0128L12.7414 8.18945ZM7.05669 8.30358L7.12888 8.75795L7.30725 9.88983L7.19256 13.3665L6.65038 10.5736L6.65019 10.5448L7.05669 8.30358ZM8.94238 8.29727L9.34994 10.5448L9.34975 10.5736L8.80619 13.3735L8.78469 12.6731L8.69988 9.86927L8.94238 8.29727Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1117 9.94043L11.0511 11.5016L9.1589 12.9757L8.7764 12.7055L9.20515 10.4971L11.1117 9.94043ZM4.89478 9.94043L6.79478 10.4971L7.22353 12.7055L6.84102 12.9757L4.94878 11.5014L4.89478 9.94043Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1886 13.5537L6.60935 14.7007L6.5991 14.2109L6.8016 14.0331H9.19754L9.40741 14.2103L9.39191 14.6997L11.7973 13.5566L10.6268 14.5238L9.21154 15.4959H6.78222L5.36785 14.5198L4.1886 13.5537Z",
    fill: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88774 12.5925L9.22999 12.8343L9.43056 14.4345L9.14031 14.1895H6.86056L6.57581 14.4395L6.76981 12.8344L7.11218 12.5925H8.88774Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1759 0.640625L16 3.11294L15.4853 5.61275L15.8518 5.89544L15.3559 6.27381L15.7286 6.56169L15.2351 7.01112L15.5381 7.23056L14.7339 8.16969L11.4358 7.20937L11.4073 7.19406L9.03056 5.18919L15.1759 0.640625ZM0.824125 0.640625L6.9695 5.18919L4.59275 7.19406L4.56419 7.20937L1.26606 8.16969L0.461875 7.23056L0.764625 7.01131L0.271375 6.56169L0.643375 6.27419L0.14 5.89469L0.520312 5.61181L0 3.11306L0.824125 0.640625Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2745 6.99927L14.7691 8.01677L15.9044 11.5158H12.9091L10.8454 11.5418L12.3462 8.61634L11.2745 6.99927ZM4.72549 6.99927L3.65355 8.61634L5.15462 11.5418L3.0918 11.5158H0.101929L1.23087 8.01677L4.72549 6.99927ZM10.2115 2.5694L9.23399 5.20934L9.02662 8.77559L8.94724 9.8934L8.94099 12.7489H7.05899L7.05287 9.89877L6.97324 8.77465L6.76574 5.20934L5.78843 2.56934L10.2115 2.5694Z",
    fill: "#F5841F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9715_150830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.e9e999596835a3c31a3e980eca16d090.svg";
export { ForwardRef as ReactComponent };